import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Page } from '../../../page/page';
import { systemUtilitiesRoutes } from '../utilities.routing';

@Component({
  selector: 'app-utilities-outlet',
  imports: [Page],
  templateUrl: './utilities-outlet.html',
  styleUrl: './utilities-outlet.scss',
})
export class UtilitiesOutlet {
  menuItems = systemUtilitiesRoutes;

  constructor(private readonly route: ActivatedRoute) {}

  parentRoute: any;

  ngOnInit(): void {
    if (this.route.routeConfig) {
      const { children, ...otherRouteAttributes } = this.route.routeConfig;
      this.parentRoute = otherRouteAttributes;
    }
  }
}
